<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle2" :subheading="subheading2" />
      <div class="header-btn-box">
        <a @click="updateyqAppInfo">保存</a>
        <a @click="toConfigRoutinePage">取消</a>
      </div>
    </div>

    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账户名称：</span>
        </div>
        <el-select v-model="aliAccountNo" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in aliAccountList"
            :key="item.aliAccountNo"
            :label="item.aliAccountName"
            :value="item.aliAccountNo">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">支付宝账号：</span>
        </div>
        <el-input v-model="aliAccountCode" size="small" style="width: 280px" disabled="" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import {getObjectURL} from '../../../../utils/toBase64'
import $ from 'jquery'
import {api} from '../../../api/ConfigRoutine'
import {errorHandler} from '../../../../utils/errorHandler'
import {nSuccess} from '../../../../utils/notice'

export default {
  components: {
    TextTitle,
    Breadcrumb},
  name: 'modify-routine',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'housing-management'
      }, {
        value: '配置管理',
        name: 'ali-config'
      }, {
        value: '常规配置'
      }],
      mainTitle: '园区信息',
      subheading: '设置接入园区的名称，园区背景图等',
      mainTitle2: '园区账户信息',
      subheading2: '学校第三方应用授权信息',
      aliAccountList: [],
      aliAccountNo: '',
      aliAccountCode: ''
    }
  },
  created () {
    this.getAliAccountList()
    this.getYqAppInfo()
  },
  methods: {
    toConfigRoutinePage () {
      this.$router.push({
        name: 'config-routine'
      })
    },
    getAliAccountList () {
      this.$axios.post(api.getAliAccountList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.aliAccountList = data
          }
        })
        .catch(errorHandler('查询支付宝账户列表失败'))
    },

    getYqAppInfo () {
      this.$axios.post(api.getYqAppInfo, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.aliAccountNo = data.aliAccountNo
            this.aliAccountCode = data.aliAccountCode
          }
        })
        .catch(errorHandler('查询园区账户信息失败'))
    },
    updateyqAppInfo () {
      this.$axios.post(api.updateyqAppInfo, {
        aliAccountCode: this.aliAccountCode,
        aliAccountNo: this.aliAccountNo
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.toConfigRoutinePage()
          }
        })
        .catch(errorHandler('修改园区账户信息失败'))
    }
  },
  watch: {
    aliAccountNo (val) {
      this.aliAccountList.map(v => {
        if (v.aliAccountNo === val) {
          this.aliAccountCode = v.aliAccountCode
        }
      })
    }
  }
}
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: -webkit-baseline-middle;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }

  .newly {
    display: inline-block;
    width: 64px;
    height: 64px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }

  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }

  #pic {
    width: 64px;
    height: 64px;
  }

  .newly span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .newly span:first-child {
    font-size: 20px;
    line-height: 20px;
    position: absolute;
    top: 15px;
  }

  .newly2 span:first-child {
    font-size: 50px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }

  .newly span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }

  .newly2 span:last-child {
    font-size: 18px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }

  .upload {
    display: inline-block;
    width: 64px;
    height: 64px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload img, .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }

  .upload b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }

  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ConfigurationManagement/ConfigRoutine/ModifyRoutine.vue